import React, { FC } from "react";

import { FormFieldLabelProps } from "./types";

export const FormFieldLabel: FC<FormFieldLabelProps> = ({
  required,
  info,
  labelDecoration,
  label,
  optionalLabel,
}) => {
  return (
    <div className="pb-1">
      <div className="flex items-center justify-between w-full">
        <div className="text-[15px] font-bold leading-tight flex items-center">
          {label}
          {/* If optional and optionalLabel is defined, show optional label */}
          {!required && optionalLabel && label && <span>&nbsp;{optionalLabel}</span>}
          {/* If required and no optional label is defined, show asterisk */}
          {!optionalLabel && required && label && <span>*</span>}
        </div>
        {labelDecoration}
      </div>
      <div className="text-[14px] font-light leading-tight">{info}</div>
    </div>
  );
};
